import {AbstractFilterComponent} from "./abstract-filter-component.js";

export class FilterOrdering extends AbstractFilterComponent {

	static selector = '.js-filter-ordering';
	static setterSelector = '.js-filter-ordering--setter';
	static labelSelector = '.js-filter-ordering--label';

	setters = Array.prototype.slice.call(document.querySelectorAll(this.constructor.setterSelector));
	labels = Array.prototype.slice.call(document.querySelectorAll(this.constructor.labelSelector));

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.bindEvents();
	}

	bindEvents() {
		let self = this;

		self.setters.forEach(setter => {
			setter.addEventListener('click', event => {
				event.preventDefault();
				self.setOrdering(setter);

				return false;
			})
		});
	}

	setOrdering(type) {
		let self = this;

		self.node.value = type.dataset.type;

		// set current text label
		self.labels.forEach(label => {
			label.innerHTML = type.dataset.label;
		});

		// remove active state
		self.setters.forEach(setter => {
			setter.classList.remove('is-active');
		});

		// set active state
		self.setters.filter(setter => setter.dataset.type === type.dataset.type).forEach(setter => {
			setter.classList.add('is-active');
		});

		self.filter.forceUpdate(0);
	}

	getFormData() {
		let self = this;

		if (! self.node.value || self.node.value === self.node.dataset.default) {
			return {};
		}

		let result = {};
		result[self.node.name] = self.node.value;

		return result;
	}
}
